export default "__VITE_ASSET__D0ItVAP9__"